module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxwYXRoIGQ9Ik0yNCAyNGM0LjQyIDAgOC0zLjU5IDgtOCAwLTQuNDItMy41OC04LTgtOHMtOCAzLjU4LTggOGMwIDQuNDEgMy41OCA4IDggOHptMCA0Yy01LjMzIDAtMTYgMi42Ny0xNiA4djRoMzJ2LTRjMC01LjMzLTEwLjY3LTgtMTYtOHoiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.svg
// module id = o9T1
// module chunks = 22